export default __webpack_public_path__ + "static/media/bg-3.1c234110.png";